import _ from 'lodash';
import { FETCH_NOTIFICATIONS_SUCCESS } from '../../actions/fetch-notifications';
import { READ_NOTIFICATION_SUCCESS } from '../../actions/read-notification';
import { NEW_NOTIFICATION } from '../../actions/user-socket';

export default (state = {}, action = {}) => {
  switch (action.type) {
    case FETCH_NOTIFICATIONS_SUCCESS:
      return _.reduce(
        action.payload,
        (newState, notification) => {
          newState[notification._id] = notification;
          return newState;
        },
        { ...state }
      );
    case READ_NOTIFICATION_SUCCESS:
      return {
        ...state,
        [action.payload._id]: action.payload,
      };
    case NEW_NOTIFICATION:
      return {
        ...state,
        [action.payload._id]: action.payload,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./app/reducers/notifications/byId.js